import { FC } from "react";
import {
  connectStats,
  connectCurrentRefinements,
} from "react-instantsearch-dom";
import {
  StatsProvided,
  CurrentRefinementsProvided,
} from "react-instantsearch-core";
import { Button } from "src/atoms/Button";
import styled from "@emotion/styled";
import { Trans } from "@lingui/macro";
import { Flex } from "@otrium/core";
import { filterFacets } from "src/organisms/AlgoliaProductList/utils/filterFacets";

const CloseButtonWrapper = styled(Flex)`
  flex: 1;
  max-height: 80px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.space.space16};
  margin-top: auto;
`;

interface StatsProps extends StatsProvided, CurrentRefinementsProvided {
  handleClose: () => void;
  selectedFacet: string;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const Stats: FC<StatsProps> = ({
  nbHits,
  items,
  handleClose,
  selectedFacet,
  keepSelectedIgnoreInActive,
  selectedCatSlug,
}) => {
  const total = nbHits;

  const currentFacet = items.filter((item) => {
    return (
      item.attribute === selectedFacet &&
      filterFacets(item, keepSelectedIgnoreInActive, selectedCatSlug)
    );
  });

  return (
    <CloseButtonWrapper>
      {currentFacet.length ? (
        <Button
          data-testid="reset-filters"
          variant="primary"
          onClick={handleClose}
          fullWidth
        >
          <Trans>Show {total} results</Trans>
        </Button>
      ) : (
        <Button
          data-testid="close-filters"
          variant="primary"
          onClick={handleClose}
          fullWidth
        >
          <Trans>Close</Trans>
        </Button>
      )}
    </CloseButtonWrapper>
  );
};

const ResultStats = connectCurrentRefinements(connectStats(Stats));

export default ResultStats;
